import { useQuery } from '@tanstack/react-query'
import { IFindJobsFilter, IFindJobsJobItem } from '../../types/findJobsType'
import apiService from '../../utils/helpers/apiService'
import { queryKeys } from '../../utils/constants'
import { buildQueryParams } from './helper'

const useFindJobsList = (filter: IFindJobsFilter, isPublic: boolean) => {
  const fetchJobList = async () => {
    const queryParams = buildQueryParams(filter)
    const url = `/jobs/find-jobs` + (queryParams ? `?${queryParams}` : '')
    return (await apiService.get({ url, withToken: !isPublic })) as {
      data: {
        count: number
        next: string
        previous: string
        results: IFindJobsJobItem[]
      }
    }
  }

  const { data, isLoading, isError, isFetching } = useQuery(
    [
      queryKeys.findJobs,
      filter.career_level,
      filter.category,
      filter.date_posted,
      filter.jobType,
      filter.location,
      filter.page,
      filter.search,
      filter.workplace,
    ],
    fetchJobList,
    {
      staleTime: Infinity,
      // keepPreviousData: true,
      enabled: isPublic ? true : !!filter.resume_id,
    }
  )

  return {
    data,
    isFetching,
  }
}

export default useFindJobsList
